import ReferencePayment from "../features/referencePayment/ReferencePayment";
import { flyzagolPaymentService } from "../features/referencePayment/referencePaymentServices";

const Flyzagol = () => (
  <ReferencePayment service={flyzagolPaymentService} />
);

export default Flyzagol;
